<div>
  <sc-flex>
    @for (inclusion of condition.inclusions; track inclusion) {
      <div>
        <div>{{inclusion}}</div>
      </div>
    }
    @for (exclusions of condition.exclusions; track exclusions) {
      <div>
        <div>{{exclusions}}</div>
      </div>
    }
    <sc-action-icon iconClass="fa-trash" (click)="onDelete()"></sc-action-icon>
  </sc-flex>
</div>